import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { AuthenticationStore } from 'authentication-data';
import { CurrentCustomerStore } from 'customers-data';

@Component({
  selector: 'ideal-punchout-authentication-header',
  imports: [],
  standalone: true,
  templateUrl: './punchout-authentication-header.component.html',
  styleUrl: './punchout-authentication-header.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PunchoutAuthenticationHeaderComponent {
  private readonly _authStore = inject(AuthenticationStore);
  private readonly _customerService = inject(CurrentCustomerStore);

  protected readonly name = computed(() => this._authStore.user()?.name ?? '');
  protected readonly customerNumber = this._customerService.customerNumber;
  protected readonly customerName = computed(() => this._customerService.customer()?.customerName ?? '');
}
